import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import DialogPopup from 'components/molecules/DialogPopup';
import tab from 'assets/images/tab.png';
import { useNavigate } from 'react-router-dom';
import TopSearch from 'components/utilized/studentDashboard/TopSearch';
import PopupSyllabus from 'components/utilized/workspace/PopupSyllabus';
import PopupResources from 'components/utilized/workspace/PopupResources';
import PopupBookmarks from 'components/utilized/workspace/PopupBookmarks';
import { Box, Grid } from '@mui/material';
import Agenda from 'components/utilized/dashboard/Agenda';
import classroom from 'assets/images/classroom.jpg'
import agenda from 'assets/images/agenda.jpg'
import Classroom from 'components/utilized/dashboard/Classroom';
import AcademicCalendar from 'components/utilized/dashboard/AcademicCalendar';
import SectionSubjectPath from 'components/utilized/studentDashboard/SectionSubjectPath';
import SectionSubjectAssignments from 'components/utilized/studentDashboard/SectionSubjectAssignments';
import SectionBigMyWork from 'components/utilized/studentDashboard/SectionBigMyWork';
import SectionMyWork from 'components/utilized/studentDashboard/SectionMyWork';
import SectionMyTarget from 'components/utilized/studentDashboard/SectionMyTarget';
import SectionMySchedule from 'components/utilized/studentDashboard/SectionMySchedule';
import Attendance from 'components/utilized/dashboard/Attendance';
import Grades from 'components/utilized/dashboard/Grades';
import { PRIMARY_PINK, PRIMARY_YELLOW } from 'utils/customizedTheme';
import EarlyWarningsSlider from 'components/utilized/dashboard/EarlyWarningsSlider';
import { useGET_subjectsQuery } from 'redux/api/subjectsApi';
import { MAX_PER_PAGE } from 'utils/constants';

const ParentWorkspacePage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
  
    const [popup, setPopup] = useState(null)
    const [popupTitle, setPopupTitle] = useState(null)
  
    const [topSearch, setTopSearch] = useState(null)
    const { data: subjects } = useGET_subjectsQuery({ page: 1, page_size: MAX_PER_PAGE })
   
    return (
        <>
              <div className="container">
  
                  <div className="workspace-top-tabs">
  
                      <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                          onClick={() => {
                              setPopupTitle(t('common.syllabus'))
                              setPopup('syllabus')
                          }}>
                          <div className="workspace-top-tab-title">{t('common.syllabus')}</div>
                      </div>
  
                      <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                          onClick={() => {
                              navigate(`/my-curriculum-map`)
                          }}>
                          <div className="workspace-top-tab-title">{t('goalbank.lessons')}</div>
                      </div>
  
                      <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                          onClick={() => {
                              setPopupTitle(t('goalbank.resources'))
                              setPopup('resources')
                          }}>
                          <div className="workspace-top-tab-title">{t('goalbank.resources')}</div>
                      </div>
  
                      <div className="workspace-top-tab" style={{ backgroundImage: `url(${tab})`}}
                          onClick={() => {
                              setPopupTitle(t('dashboard.bookmarks'))
                              setPopup('bookmarks')
                          }}>
                          <div className="workspace-top-tab-title">{t('dashboard.bookmarks')}</div>
                      </div>
                      
                  </div>
  
                  <div style={{ height: '40px' }} />
  
                  <TopSearch handleSearch={(qry) => {
                      setPopupTitle(t('goalbank.resources'))
                      setTopSearch(qry)
                      setPopup('resources')
                  }} />


                <div style={{ height: '100px' }} />

            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <Box className='thick-border transparent-background' sx={{
                    height: '350px',
                    backgroundImage: `url(${agenda})`, 
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center right',
                    backgroundSize: 'cover', 
                    }}><Agenda /></Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box className='thick-border dashboard-parent-calendar' ><AcademicCalendar /></Box>
                </Grid>
            </Grid>

            <h1 className='workspace-title'>{t('dashboard.from-the-teacher')}</h1>
            <SectionSubjectPath />  
            <SectionSubjectAssignments /> 
                        
            <h1 className='workspace-title'>{t('dashboard.child-work',{name: 'Maria'})}</h1>
            <SectionMyWork />  

            <h1 className='workspace-title'>{t('dashboard.where-is-child-now', {name: 'Maria'})}</h1>
            <SectionMyTarget />  


            <h1 className='workspace-title'>{t('dashboard.child-schedule-today', {name: 'Maria'})}</h1>
            <SectionMySchedule />           

            <div style={{ height: '40px' }} />

            <Grid container spacing={4}>             
                <Grid item xs={12} md={6} lg={4}>
                    <Attendance />
                </Grid>
                {subjects && subjects.results.map(s =>
                    <Grid item xs={12} md={6} lg={6} xl={3} key={s.id}>
                        <Grades subject={s} /> 
                    </Grid>).slice(0,2)}
            </Grid>





         </div>
  
          <DialogPopup
              title={popupTitle}
              open={!!popup}
              onClose={() => setPopup(null)}
              popupWidth={'1400px'}
          >
             <>
              {popup === 'syllabus' && <PopupSyllabus />}
              {popup === 'resources' && <PopupResources qry={topSearch} />}
              {popup === 'bookmarks' && <PopupBookmarks />}
             </>
          </DialogPopup>
        
        </>
  )
}
export default ParentWorkspacePage
